import { useState } from "react";
import { Link } from 'react-router-dom';
import { hotels, rooms } from './data';
import { motion } from 'framer-motion';
const ITEMS_PER_PAGE = 2;
const BlogPage = () => {
  const [selectedButton, setSelectedButton] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const slideInFromBottom = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 0.8, ease: "easeOut" },
  };
  const getFilteredData = () => {
    if (selectedButton === 'Hotels') return hotels;
    if (selectedButton === 'Rooms') return rooms;
    return [...hotels, ...rooms];
  };

  const filteredData = getFilteredData();
  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleFilterChange = (btn) => {
    setSelectedButton(btn);
    setCurrentPage(1); // Reset to first page on filter change
  };

  return (
    <>



      <section className="relative flex justify-center items-center w-full h-[852px] md:h-[656px] lg:h-[588px]">

        <div className=" absolute  inset-0 bg-black bg-opacity-20">

          <img
            src="/images/Blog/Hero1.webp"
            alt="Hero Image"
            className="absolute  w-full h-full object-cover object-center "
          />


        </div>

        {/* Centered Content */}
        <div className="flex flex-col items-center justify-center  text-center text-[#FFFFFF] absolute top-[360px] md:top-[274px] lg:top-[120px] px-[16px] md:px-[75px] lg:px-[300px]">
          <h2 className="w-[37px] h-[22px] md:w-[50px] md:h-[26px] lg:w-[78px] lg:h-[49px] font-lora font-medium text-[18px] leading-[22px] md:text-[24px] md:leading-[26px] lg:text-[38px] lg:leading-[100%] tracking-[0px] text-white mb-[12px] md:mb-[16px] lg:mb-[24px]">
            Blog
          </h2>
          <h1 className="w-[270px] h-[34px] md:w-[309px] md:h-[38px] lg:w-[501px] lg:h-[60px] font-lora font-medium text-[28px] leading-[34px] md:text-[32px] md:leading-[38px] lg:text-[52px] lg:leading-[60px] tracking-[0%] text-center">
            Articles & Resources
          </h1>
          <p className="w-[311px] h-[60px] md:w-[455px] md:h-[40px] lg:w-[651px] lg:h-[48px] font-outfit font-[350] text-[12px] md:text-[14px] lg:text-[16px] leading-[20px] md:leading-[20px] lg:leading-[24px] tracking-[0%] md:tracking-[0%] lg:tracking-[0px] text-center text-white mt-8">
            Explore expert insights, design inspiration, and the latest updates in real estate and interiors.
            <br className="hidden lg:block" />
            Stay informed and inspired with curated articles tailored for modern living.
          </p>
        </div>
      </section>



      {/* Content section */}

      {/* <section className="relative w-full h-auto mb-20">
                <div className="w-full pt-20 flex justify-center items-center gap-4">
                    {['All', 'Hotels', 'Rooms'].map((btn, index) => (
                        <button
                            key={index}
                            className={`py-2 px-4 text-sm rounded ${selectedButton === btn
                                ? 'bg-black text-white'
                                : 'bg-transparent text-black'
                                }`}
                            onClick={() => setSelectedButton(btn)}
                        >
                            {btn}
                        </button>
                    ))}
                </div>


                <div className="flex flex-col lg:flex-row items-center justify-center w-full px-6 py-10">

                    <div className="relative mb-6 lg:mb-0 lg:mr-8">
                        <img
                            src="/images/Blog/blog1.webp"
                            alt="Image1"
                            className="w-[90%] sm:w-[500px] h-auto sm:h-[450px] md:w-[550px] md:h-[500px] lg:w-[500px] lg:h-[450px] rounded-lg shadow-lg object-cover"
                        />
                    </div>


                    <div className="w-full sm:w-[500px] md:w-[500px] lg:w-[600px] h-auto sm:h-[450px] md:h-[400px] lg:h-[350px] p-2  lg:mt-1">
                        <h2 className="text-lg font-bold  font-lora">A Niche in Town</h2>
                        <p className="text-gray-700 text-sm  leading-relaxed  font-lora">
                            Planning for a surprise and everything is going as planned and the only thing to be filled is a place to stay. Don't be that boring person who plans everything at last and you mess up everything in every possible way. The world is wide and you can find places all around the world. But make sure you choose the apt one. The perfect one. Just think of a situation where you can find a niche wherever you go. And you don't have to bother about the comfort because they all put forward your ultimate comfort .
                            Here it presents Znorm Homes for your comfort. Let anything be your occasion and requirements Znorm is here with the ultimate comfort in your staycation. They present it in  both Kochi and Bangalore.  Here your comfort meets an exceptional destination. And one can feel like home too. We don't get you inside a puzzle. Everything under Znorm is easy to go with. Starting from the searching for your niche to booking it and cross checking your requirements and comfortability everything is an easy to go process. All you need to do is go to the website https://homes.znorm.org/ and see through your preferable locations. So far they targeted the prime spots for a city to present you with easy access to the vital spots and destinations.
                        </p>
                    </div>
                </div>



                <div className="flex flex-col lg:flex-row-reverse items-center justify-center w-full px-6 py-10">

                    <div className="relative mb-6 lg:mb-0 lg:ml-8">
                        <img
                            src="/images/Blog/blog2.webp"
                            alt="Image1"
                            className="w-[90%] sm:w-[500px] h-auto sm:h-[450px] md:w-[550px] md:h-[500px] lg:w-[500px] lg:h-[450px] rounded-lg shadow-lg object-cover"
                        />
                    </div>


                    <div className="w-full sm:w-[500px] md:w-[500px] lg:w-[600px] h-auto sm:h-[450px] md:h-[400px] lg:h-[350px] p-6 mt-2 lg:mt-1">
                        <h2 className="text-lg font-bold  font-lora mb-4">A Niche in Town</h2>
                        <p className="text-gray-700 text-sm  font-lora leading-relaxed">
                            Planning for a surprise and everything is going as planned and the only thing to be filled is a place to stay. Don't be that boring person who plans everything at last and you mess up everything in every possible way. The world is wide and you can find places all around the world. But make sure you choose the apt one. The perfect one. Just think of a situation where you can find a niche wherever you go. And you don't have to bother about the comfort because they all put forward your ultimate comfort .
                            Here it presents Znorm Homes for your comfort. Let anything be your occasion and requirements Znorm is here with the ultimate comfort in your staycation. They present it in  both Kochi and Bangalore.  Here your comfort meets an exceptional destination. And one can feel like home too. We don't get you inside a puzzle. Everything under Znorm is easy to go with. Starting from the searching for your niche to booking it and cross checking your requirements and comfortability everything is an easy to go process. All you need to do is go to the website https://homes.znorm.org/ and see through your preferable locations. So far they targeted the prime spots for a city to present you with easy access to the vital spots and destinations.
                        </p>
                    </div>
                </div>


            </section> */}



      <section className="relative w-full h-auto  flex flex-col items-center justify-center   px-4 md:px-[64px]  lg:px-[106px] ">
        {/* Filter Buttons */}
        <div className="w-full pt-[40px] md:pt-[64px] lg:pt-[72px] flex justify-center items-center gap-4 ">
          {['All', 'Hotels', 'Rooms'].map((btn) => (
            <button
      key={btn}
      className={`
        ${btn === 'All' 
          ? 'w-[72px] md:w-[88px] lg:w-[88px]' 
          : 'w-[80px] md:w-[100px] lg:w-[100px]'
        }
        h-[40px] md:h-[44px] lg:h-[48px]
        ${btn === 'All' 
          ? 'rounded-[20px] md:rounded-[25px] lg:rounded-[25px]' 
          : 'rounded-[25px]'
        }
        p-[10px]
        font-lora
        font-medium
        text-sm
        ${selectedButton === btn ? 'bg-black text-white' : 'bg-transparent text-black'}
      `}
      onClick={() => handleFilterChange(btn)}
    >
      {btn}
    </button>
          ))}
        </div>

        {/* Cards */}

        {paginatedData.map((item, index) => (
          <motion.div key={item.id} className={`hidden sm:flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center justify-center lg:w-[1300px] lg:h-[456px] w-full h-[778px] lg:mt-[200px] md:mt-[120px] mt-[100px]`} {...slideInFromBottom}>
            <div className="relative mb-6 lg:mb-0 lg:w-[640px] lg:h-[456px] w-[362px] h-[264px] lg:px-[56px]  " >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full rounded-lg shadow-lg object-cover"
              />
            </div>
            <div className="w-full sm:w-[500px] md:w-[500px] lg:w-[604px] h-auto lg:h-[440px] md:h-[400px]   mt-2 lg:mt-1">
              <h2 className="w-[138px] h-[26px] md:w-[304px] md:h-[24px] lg:w-[604px] lg:h-[31px] font-lora font-medium text-[18px] md:text-[18px] lg:text-[24px] leading-[26px] md:leading-[24px] lg:leading-[100%] tracking-[0px] mb-2">
  {item.title}
</h2>
              <p className="outfit-text leading-relaxed">{item.description}</p>
            </div>
          </motion.div>
        ))}

        {/* for mobile only  */}

<div className="block sm:hidden">
          {paginatedData.map((item) => (
            <motion.div key={item.id} className="flex flex-col w-full mt-[80px]"{...slideInFromBottom}>
              <div className="mb-4">
                <h2 className=" w-auto min-w-[138px] h-[26px] font-lora font-medium text-[18px] leading-[26px] tracking-[0px] mb-2  text-center mx-auto">{item.title}</h2>
                
                <p className="outfit-text ">
                  {item.description.split('. ')[0] + '.'}
                </p>
              </div>
              <div className="mb-4">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-[220px] object-cover rounded-lg shadow-md"
                />
              </div>
              <div>
                <div className="flex justify-center">
                  <p className="w-[362px] h-[160px] font-outfit font-[350] text-[12px] leading-[20px] tracking-[0%] text-center text-[#707070]">
                  {item.description.split('. ').slice(1).join('. ')}
                </p>
                </div>
                
              </div>
            </motion.div>
          ))}
        </div>


        {/* Pagination Controls */}
        {/* {totalPages > 1 && (
          <div className="flex justify-center mt-20 gap-2">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                className={`px-3 py-1 rounded ${currentPage === i + 1 ? 'bg-black text-white' : 'bg-gray-200'}`}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </button>
            ))}
          </div>
        )} */}
      </section>


      <section className="w-full flex flex-col justify-center items-center mt-[120px] md:mt-[134px] lg:mt-[200px]">
        <div className="relative w-full h-[240px] md:h-[256px] lg:h-[356px] flex flex-col justify-center items-center mx-auto">

          <img
            src="/images/Blog/blogframe1.webp"
            alt="blogframe Image"
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>

          <div className="absolute inset-0 flex flex-col sm:flex-row items-center justify-center px-2 mt-4 lg:mt-24 lg:px-4">
            <div className="w-[362px] h-[168px] gap-[40px] sm:w-[704px] sm:h-[88px] sm:gap-[112px] lg:w-[1298px] lg:h-[88px] lg:gap-[267px] px-4 rounded-lg flex flex-col sm:flex-row justify-between items-start text-start sm:text-left">
              {/* Left side (Title and Description) */}
              <div className="w-[362px] h-[88px] gap-[16px] md:w-[320px] lg:w-[727px] lg:ml-10 md:ml-10 mb-2">
                <h2 className="w-[362px] h-[26px] md:w-[320px] md:h-[30px] lg:w-[727px] lg:h-[49px] font-lora font-medium text-[18px] md:text-[24px] lg:text-[38px] leading-[26px] md:leading-[30px] lg:leading-[100%] tracking-[0px] text-white mb-2 sm:ml-[10px]  md:ml-[2px] lg:ml-[2px]">
                  Luxe selections
                </h2>
                <p className="text-white text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-[350]">
                  Escape to the epitome of luxury in our handpicked ultra-premium stays
                  packed with signature services..
                </p>
              </div>

              {/* Button Section */}
              <div className="w-[264px] h-[40px] gap-[16px] shadow-[0px_4px_6px_0px_#0000004D] md:w-[272px] md:h-[44px] md:shadow-[0px_4px_6px_0px_#0000004D] lg:w-[304px] lg:h-[48px] lg:shadow-[0px_4px_6px_0px_#000000] flex justify-end ml-[60px] ">
              <button className="
  w-[124px] h-[40px] gap-[10px] p-[10px] px-[12px] rounded-[4px] shadow-[0px_2px_8px_0px_#00000017]
  md:w-[132px] md:h-[44px] md:gap-[10px] md:p-[10px] md:px-[12px] md:rounded-[4px] md:shadow-[0px_2px_8px_0px_#00000017]
  lg:w-[148px] lg:h-[48px] lg:gap-[10px] lg:p-[10px] lg:px-[12px] lg:rounded-[4px] lg:shadow-[0px_2px_12px_0px_#00000026]
  font-outfit bg-transparent border border-white text-white text-[12px] md:text-[14px] lg:text-[16px] 
  hover:bg-white hover:text-black transition">
  Browse Rooms
</button>
                <Link to="/contact">
  <button className="
    w-[124px] h-[40px] gap-[10px] p-[10px] px-[12px] rounded-[4px] border-[0.7px]
    md:w-[124px] md:h-[44px] md:gap-[10px] md:p-[10px] md:px-[12px] md:rounded-[4px] md:border-[0.7px]
    lg:w-[140px] lg:h-[48px] lg:gap-[10px] lg:p-[10px] lg:px-[12px] lg:rounded-[4px] lg:border-[1px]
    font-outfit bg-transparent border-white text-white text-[12px] md:text-[14px] lg:text-[16px]  
    hover:bg-white hover:text-black transition">
    Contact
  </button>
</Link>
                
              </div>
            </div>
          </div>
        </div>
      </section>



    </>
  )
}
export default BlogPage